export enum CertificazioneCompetenzeStato {
    completa = "COMPLETA",
    nonCompleta = "NON_COMPLETA"
}